import store from '../../vuex'

export default function install (Vue) {
  Vue.prototype.$can = function (param) {
    if (!param) {
      return false
    }
    return store.getters.permissions.some(item => item.name === param)
  }
}



// WEBPACK FOOTER //
// ./src/plugins/access/index.js